<template>
    <div style="height:100%;width:100%;display:flex;flex-direction:row;">
        <Portlet :class="['main-portlet', $route.name]" :fullHeight="true" :headSeparator="true">
            <template slot="Title">
                <router-view name="subPageHeader"></router-view>
            </template>
            <template slot="Options">
                <router-view name="pageActions"></router-view>
            </template>
            <template slot="PortletNav">
                <router-view name="pageSubMenu"></router-view>
            </template>
            <template slot="Search">

            </template>
            <template slot="Content">
                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </template>
        </Portlet>
        <router-view name="rightPanel"></router-view>
    </div>
</template>

<script>
    import store from '@/store';
    import Portlet from'@/components/common/Portlet.vue';
    import Translations from '@/store/translations';
    import EventBus from '@/eventbus';

    export default {
        name: 'MasterPlanning',
        store,
        created() {
            EventBus.$on("dayTemplateDelete", function (data) { console.log("Delete Daytemplate", data) })
            EventBus.$on("dayTemplateDuplicate", function (data) { console.log("Duplicate Daytemplate", data) })
            EventBus.$on("dayTemplateEdit", function (data) { console.log("Edit Daytemplate", data) })
        },
        computed: {
            Translations: () => Translations,
        },
        components: {
            Portlet
        },
    };

</script>

<style scoped>

</style>
